import { Component, computed, inject, input, output } from '@angular/core';
import { roleLabel } from '../../core/rbac/role-label';
import { roleDeskDescription } from '../../core/i18n/role-desk.i18n';
import { DeskLangService } from '../../core/services/desk-lang.service';

@Component({
  selector: 'app-role-chooser',
  standalone: true,
  templateUrl: './role-chooser.component.html',
  styleUrl: './role-chooser.component.scss',
})
export class RoleChooserComponent {
  private readonly deskLang = inject(DeskLangService);

  readonly displayName = input('');
  readonly roles = input.required<string[]>();
  readonly busy = input(false);

  readonly choose = output<string>();
  readonly signOut = output<void>();

  readonly t = this.deskLang.copy;

  readonly lang = this.deskLang.lang;

  label(role: string): string {
    return roleLabel(role);
  }

  description(role: string): string {
    return roleDeskDescription(role, this.lang());
  }

  readonly welcomeLine = computed(() => {
    const name = (this.displayName() || '').trim();
    const welcome = this.t().welcome;
    return name ? `${welcome}, ${name}` : welcome;
  });

  onPick(role: string): void {
    if (this.busy()) return;
    this.choose.emit(role);
  }

  onSignOut(): void {
    if (this.busy()) return;
    this.signOut.emit();
  }

  setLang(next: 'en' | 'hi'): void {
    this.deskLang.setLang(next);
  }
}
